export enum ReportingMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_POWER_BI_ACCESS_DETAILS = 'SET_POWER_BI_ACCESS_DETAILS',
  SET_POWER_BI_CONTRACTS_ACCESS_DETAILS = 'SET_POWER_BI_CONTRACTS_ACCESS_DETAILS',
  SET_POWER_BI_CONTRACT_TOKEN_DETAILS = 'SET_POWER_BI_CONTRACT_TOKEN_DETAILS'
}
